module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_macarrão.9c8c962c.png";